import * as React from "react"

import {
  cn
} from "@/lib/utils"

const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.ComponentProps<"textarea">
>(({
  className, ...props 
}, ref) => {
  return (
    <textarea
      className={cn(
        "bg-background roundedplaceholder_text-muted-foreground disabled_cursor-not-allowed disabled_opacity-50 flex min-h-[80px] w-full border border-[#c5c5c5] px-3 py-2 text-sm outline-none",
        className
      )}
      ref={ref}
      {...props}
    />
  )
})

Textarea.displayName = "Textarea"

export {
  Textarea
}

